module.exports = __webpack_public_path__ + "static/forecast/weather/daymodrain-0e94d6b8f6a4c2f8b83f3e1bbdbaceff.svg";